export const sendJSError = (processName, method, data) => {
  try {
    const dataToSend = JSON.stringify(data);

    if (window.IC && window.IC.trackErrorCtz) {
      window.IC.trackErrorCtz(processName, '', method, dataToSend);
    }
  } catch (err) {
    console.log('IC is not defined');
  }
};
